import { render, staticRenderFns } from "./POIFilter.vue?vue&type=template&id=3bb3e992"
import script from "./POIFilter.js?vue&type=script&lang=js&external"
export * from "./POIFilter.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports